import React from 'react'

const BatteryForm = () => {
  return (
    <div>BatteryForm</div>
  )
}

export default BatteryForm